import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IParidadResponse, 
  IParidadRequest, 
  IParidadSaveRequest, 
  IParidadSaveResponse 
} from '../interfaces/paridad.interface';

@Injectable({
  providedIn: 'root'
})
export class ParidadService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Paridades/sospa_paridadesList`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}Paridades/sospa_paridadesAdd`;
  private readonly API_URL_EDIT = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetCatag5`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}Paridades/sospa_paridadesDelete`;

  constructor(private http: HttpClient) { }

  getParidades(request: IParidadRequest): Observable<IParidadResponse> {
    return this.http.post<IParidadResponse>(this.API_URL, request);
  }
  
  getParidadForEdit(par2ODBC: number): Observable<IParidadResponse> {
    const payload: IParidadRequest = {
      que: 5,
      tope: '',
      cmd: '',
      fecha: '',
      descripcion: '',
      paridaddolar: 0,
      paridadudis: 0,
      par2ODBC: par2ODBC
    };
    const url = `${environment.apiNewBackBaseUrl}Paridades/sospa_paridadesListDet`;
    return this.http.post<IParidadResponse>(url, payload);
  }

  saveParidad(payload: IParidadSaveRequest): Observable<IParidadSaveResponse> {
    return this.http.post<IParidadSaveResponse>(this.API_URL_SAVE, payload);
  }

  deleteParidad(par2ODBC: number): Observable<IParidadSaveResponse> {
    const payload: IParidadSaveRequest = {
      que: 5,
      tope: '',
      cmd: '',
      fecha: '',
      descripcion: '',
      paridaddolar: 0,
      paridadudis: 0,
      par2ODBC: par2ODBC
    };
    return this.http.post<IParidadSaveResponse>(this.API_URL_DELETE, payload);
  }

  updateParidad(payload: IParidadSaveRequest): Observable<IParidadSaveResponse> {
    const url = `${environment.apiNewBackBaseUrl}Paridades/sospa_paridadesUpd`;
    return this.http.post<IParidadSaveResponse>(url, payload);
  }
} 